import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Legal.module.css';

export function TermsPage() {
  const { t } = useTranslation();

  return (
    <article className={styles.page}>
      <header className={styles.header}>
        <Link to="/" className={styles.back}>{t('common.back')}</Link>
        <h1>{t('legal.termsTitle')}</h1>
      </header>

      <div className={styles.content}>
        <p className={styles.updated}>{t('legal.lastUpdated')}</p>

        <section>
          <h2>{t('legal.terms.serviceTitle')}</h2>
          <p>{t('legal.terms.serviceBody')}</p>
        </section>

        <section>
          <h2>{t('legal.terms.accountTitle')}</h2>
          <p>{t('legal.terms.accountBody')}</p>
        </section>

        <section>
          <h2>{t('legal.terms.conductTitle')}</h2>
          <p>{t('legal.terms.conductBody')}</p>
        </section>

        <section>
          <h2>{t('legal.terms.liabilityTitle')}</h2>
          <p>{t('legal.terms.liabilityBody')}</p>
        </section>

        <aside className={styles.note}>{t('legal.legalNote')}</aside>
      </div>
    </article>
  );
}
